import React,{useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import { HashLink as Link } from 'react-router-hash-link';
import {makeStyles} from '@material-ui/core'
import logo from '../images/anjan_logo.png'
import {motion} from 'framer-motion'
function Navigation(props) {
 
    const useStyles = makeStyles((theme)=>({

        listitem:{
            color: '#989899',
            marginBottom:'30px',
            paddingBottom:'3px', 
           width:props.closeHam? '200px':'80%',
            cursor: 'pointer',
            
            transition: 'transform 0.3s',
            "&:hover": {
                color: '#4CBBC6',
               transform:'scale(1.13)'
              },
              [theme.breakpoints.between('sm','md')]:{
                  fontSize:'22px'
              }
        
        },
      
        
        
        
        activeRoute:{
            color: '#4CBBC6 ',
            transform:'scale(1.13)',
            
            marginBottom:'30px',
            paddingBottom:'3px', 
            width:'80%',
            cursor: 'pointer',
        },
        logoHolder:{
            margin:'30px 0 0 40px',
            [theme.breakpoints.down('md')]:{
                marginTop:'50px'
            }

        }
        
        }));
    const classes = useStyles();
    const location = useLocation();
let current_path = (location.hash.split('#')[1]);


useEffect(() => {
    if(props.closeHam){
        props.closeHam()
    }
  
   
}, [current_path]);


const ulVariant = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
          delayChildren:2,
        staggerChildren: 0.35
      }
    }
  }
  const liVariant = {
    hidden: { opacity: 0 },
    show: { opacity: 1 }
  }

    return (
        <>
        <div className={classes.logoHolder} >

<img src={logo} height="70"></img>

</div>
        <motion.ul style={{listStyle:'none',marginTop:props.closeHam?'60px':'150px'}} 
        variants={ulVariant}
        initial="hidden"
        animate="show"
        >
                
        <Link
smooth to="/#home"
style={{textDecoration:'none'}}>    
 <motion.li className={classes.listitem} variants={liVariant}>Home</motion.li>
</Link>

<Link
smooth  to="/#about_me"
style={{textDecoration:'none'}}>      
<motion.li className={classes.listitem} variants={liVariant}>About Me</motion.li>
</Link>


<Link
smooth  to="/#my_works"
style={{textDecoration:'none'}}
>        <motion.li className={classes.listitem} variants={liVariant}>My work</motion.li>
</Link>

<Link
smooth to="/#contact_me"
style={{textDecoration:'none'}}


>        <motion.li className={classes.listitem} variants={liVariant}>Contact Me</motion.li>
</Link>
            

        </motion.ul>
        </>
    )
}

export default Navigation
